// extracted by css-extract-rspack-plugin
export default {"BranchInfoBarContainer":"BranchInfoBar-module__BranchInfoBarContainer__DGzPkuI","Box":"BranchInfoBar-module__Box__qi6PQGe"};